import React, { Component, Fragment } from "react";
import { browserHistory } from 'react-router';

import HeaderPB from "./headers/HeaderPB/Web";
import HeaderPBK from "./headers/HeaderPBK/Web";
import HeaderGAP from "./headers/HeaderGAP/Web";
import NewHeaderGAP from "./headers/NewHeaderGAP/Web";
import NewHeaderPB from "./headers/NewHeaderPB/Web";
import HeaderWES from "./headers/HeaderWestelm/Web";
import HeaderWS from "./headers/HeaderWS/Web";
import HeaderTRU from "./headers/HeaderTRU/Web";
import HeaderLP from "./headers/HeaderLP/Web";
import HeaderContainerTRU from "../ToysNewHeader/Header/HeaderContainer";
import HeaderContainerGAP from "../GapNewHeader/Header/HeaderContainer";
import HeaderContainerWLM from "../WlmNewHeader/Header/HeaderContainer";
import HeaderContainerPB from "../PbNewHeader/Header/HeaderContainer";
import HeaderContainerPBK from "../PbkNewHeader/Header/HeaderContainer";
import HeaderContainerWS from "../WsNewHeader/Header/HeaderContainer";

import { connect } from "react-redux";

import HeaderPBWap from "./headers/HeaderPB/Wap";
import HeaderPBKWap from "./headers/HeaderPBK/Wap";
import HeaderGAPWap from "./headers/HeaderGAP/Wap";
import HeaderWESWap from "./headers/HeaderWestelm/Wap";
import HeaderWSWap from "./headers/HeaderWS/Wap";
import HeaderTRUWap from "./headers/HeaderTRU/Wap";
import HeaderLPWAP from "./headers/HeaderLP/Wap";
import HeaderContainer from "../NewHeader/Header/HeaderContainer";

import commonUtil from "./../../utils/commonUtil";
import serverClientUtil from "./../../utils/serverClientUtil";
import { constChannel } from "./../../utils/clientConstant";
import AppEvents from "./../../pages/App/AppEvents";
import {updateGiftListHeader} from "../../components/globleObject/actions"
import { setGiftListTransferenceStatementTab } from "../../pages/eventManagement/page/GiftList/actions";
const channel = commonUtil.getChannel();
const applicationRoutes = commonUtil.getApplicationRoutes();
const { WEB, WAP } = constChannel;

@connect((store) => ({
  megaMenuData: store.megaMenuData.data,
  cartCountData: store.cartCountData.data,
  SearchedPoductData: store.SearchedPoductData.data,
  globalObject: store.globleObject,
}),{updateGiftListHeader,setGiftListTransferenceStatementTab})
export default class GREcomHeader extends Component {
  constructor(props) {
    super(props);
    this.externalClickHandlerForWapBackButton = null;
    this.switchForheader = true;
    this.user = {};
  }

  componentDidMount() {
    if (channel === WAP) {
      AppEvents.hookEvent(
        AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED_GR,
        this.hookWapBackClickHandler
      );
    }
  }
  componentWillUnmount() {
    if (channel === WAP) {
      AppEvents.unhookEvent(
        AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED_GR
      );
    }
  }

  getCookie = (name) => {
    const matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
          "=([^;]*)"
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };

  hookWapBackClickHandler = (func) => {
    if (func && typeof func === "function") {
      this.externalClickHandlerForWapBackButton = func;
    }
  };

  wapReturnClickHandler = (e) => {
    const { state = {} } = this.props.location || {};
    const { isEventManagement, eventId } = state;
    if (isEventManagement) {
      browserHistory.push({
        pathname: commonUtil.getRouteByParameter(applicationRoutes.giftList, { eventID: eventId }),
        state: {
          activeSection: 'direcciones-de-entrega',
        },
      })
      return true;
    }
    
    if (
      this.externalClickHandlerForWapBackButton &&
      typeof this.externalClickHandlerForWapBackButton === "function"
    ) {
      this.externalClickHandlerForWapBackButton(e);
    }
    else {
       browserHistory.goBack();
    }
  };

  giftListWapreturnClickHandler = (e) => {
    const currentRoute = this.props.Router && this.props.Router.location && this.props.Router.location.pathname ? this.props.Router.location.pathname : '';
    if (this.props?.globalObject?.giftListHeader != "Mesa de regalos" && (this.props?.globalObject?.giftListHeader != "Statements Table Pages")){
      this.props.updateGiftListHeader("Mesa de regalos");
      browserHistory.push(currentRoute);
    } else if (this.props?.globalObject?.giftListHeader == "Statements Table Pages") {
      this.props.setGiftListTransferenceStatementTab(true);
      const { params } = this.props;
      browserHistory.push(commonUtil.routeTo(applicationRoutes.giftList, { eventID: params.eventID }));
    }
    else {
      browserHistory.push('/')
    }
  }

  handleLoginWithAuth0 = () => {
    const url = serverClientUtil.getLPFullURL();
    const redirectUrl = "https:" + url + "/login";
    const redirectBackUrl = window.location.origin;
    window.location.replace(
      `${redirectUrl}?redirectAfterLoginHref=${redirectBackUrl}&originalRedirectHref=${window.location.origin}`
    );
  };

  handleLogoutWithAuth0 = async (email, callback, url) => {
    const redirectUrl = "https:" + url + "/logout";
    const redirectBackUrl = window.location.origin;
    const userLogout = {};
    userLogout.login = email;
    const callbackResponse = await callback(userLogout);
    console.log("LogoutcallbackResponse", callbackResponse);
    let favoriteStoreName = localStorage.getItem('favoriteStoreName');
    if(favoriteStoreName){
      localStorage.removeItem("favoriteStoreName");
      localStorage.removeItem("favoriteStoreId");
    }
    window.location.replace(`${redirectBackUrl}`);
  };

  render() {
    const brand = serverClientUtil.getBrand();
    const { Router, params, isAvailableHeader } = this.props;
    const routeProps = params || "";
    let header = "";
    let showHeader = true;
    let hideWapHeaderForGiftList = false;
    const routeDataWAP = [
      applicationRoutes.mesaType,
      applicationRoutes.openType,
      applicationRoutes.celebrationType,

      applicationRoutes.createFirst_communion,

      applicationRoutes.createConfirmations,

      applicationRoutes.createBar_Mitzvah,
      applicationRoutes.createBat_Mitzvah,

      applicationRoutes.createMeetings,
      applicationRoutes.createChildrensParty,
      applicationRoutes.createAniversary,

      applicationRoutes.createFarewell,
      // applicationRoutes.addDeliveryAddress,
      applicationRoutes.benefits,
      applicationRoutes.createAccount,
    ];

    const routeDataWEB = [
      applicationRoutes.mesaType,
      applicationRoutes.openType,
      applicationRoutes.celebrationType,
      applicationRoutes.createFirst_communion,
      applicationRoutes.createConfirmations,
      applicationRoutes.createBar_Mitzvah,
      applicationRoutes.createBat_Mitzvah,
      applicationRoutes.createMeetings,
      applicationRoutes.createChildrensParty,
      applicationRoutes.createAniversary,
      applicationRoutes.createFarewell,
      // applicationRoutes.addDeliveryAddress,
      applicationRoutes.benefits,
      applicationRoutes.createAccount,
      applicationRoutes.partialTransference, // Account Transference and clouser
      applicationRoutes.partialConfirmation,
      applicationRoutes.closureTransference,
      applicationRoutes.closureConfirmation,
    ];
    const currentRoute =
      (Router && Router.location && Router.location.pathname) || "";
    const routeData = channel === WEB ? routeDataWEB : routeDataWAP;

    const isResumendelacuentaTablePages =
      currentRoute ==
        commonUtil.getRouteByParameter(
          applicationRoutes.physicalGifts,
          routeProps,
        ) ||
      currentRoute ==
        commonUtil.getRouteByParameter(
          applicationRoutes.electronicsGift,
          routeProps,
        ) ||
      currentRoute ==
        commonUtil.getRouteByParameter(
          applicationRoutes.personalPurchases,
          routeProps,
        );

    if (commonUtil.getChannel() === WAP && ((currentRoute ==  commonUtil.getRouteByParameter(applicationRoutes.giftList, routeProps)) || isResumendelacuentaTablePages)  ) {
       hideWapHeaderForGiftList = true;
    }
    if (this.switchForheader && routeData && routeData.length > 0) {
      routeData.map((info) => {
        const exactRoute = commonUtil.getRouteByParameter(info, routeProps);
        if (exactRoute && exactRoute === currentRoute) {
          showHeader = false;
        }
        return showHeader;
      });
    }

    if (commonUtil.getChannel() === WEB && showHeader) {
      switch (brand) {
        case 'WS':
          header = isAvailableHeader ? (
            <HeaderContainerWS
              handleLoginWithAuth0={this.handleLoginWithAuth0}
              handleLogoutWithAuth0={this.handleLogoutWithAuth0}
              />
            ) : (
            <HeaderWS
              handleLoginWithAuth0={this.handleLoginWithAuth0}
              handleLogoutWithAuth0={this.handleLogoutWithAuth0}
            />
          );
          break;
        case 'PB':
          header = isAvailableHeader ? (
            <HeaderContainerPB
              handleLoginWithAuth0={this.handleLoginWithAuth0}
              handleLogoutWithAuth0={this.handleLogoutWithAuth0}
            />
          ) : (
            <HeaderPB
              handleLoginWithAuth0={this.handleLoginWithAuth0}
              handleLogoutWithAuth0={this.handleLogoutWithAuth0}
            />
          );
          break;
        case 'PBK':
          header = isAvailableHeader ? (
            <HeaderContainerPBK
              handleLoginWithAuth0={this.handleLoginWithAuth0}
              handleLogoutWithAuth0={this.handleLogoutWithAuth0}
            />
            ) : (
            <HeaderPBK
              handleLoginWithAuth0={this.handleLoginWithAuth0}
              handleLogoutWithAuth0={this.handleLogoutWithAuth0}
            />
          );
          break;
        case 'GAP':
          header = isAvailableHeader ? (
            <HeaderContainerGAP
              handleLoginWithAuth0={this.handleLoginWithAuth0}
              handleLogoutWithAuth0={this.handleLogoutWithAuth0}
            />
          ) : (
            <HeaderGAP
              handleLoginWithAuth0={this.handleLoginWithAuth0}
              handleLogoutWithAuth0={this.handleLogoutWithAuth0}
            />
          );
          break;
        case 'WLM':
          header = isAvailableHeader ? (
            <HeaderContainerWLM
              handleLoginWithAuth0={this.handleLoginWithAuth0}
              handleLogoutWithAuth0={this.handleLogoutWithAuth0}
            />
            ) : (
            <HeaderWES
              handleLoginWithAuth0={this.handleLoginWithAuth0}
              handleLogoutWithAuth0={this.handleLogoutWithAuth0}
            />
          );
          break;
        case 'LP':
          header = isAvailableHeader ? (
            <HeaderContainer
              handleLoginWithAuth0={this.handleLoginWithAuth0}
              handleLogoutWithAuth0={this.handleLogoutWithAuth0}
            />
          ) : (
            <HeaderLP
              handleLoginWithAuth0={this.handleLoginWithAuth0}
              handleLogoutWithAuth0={this.handleLogoutWithAuth0}
            />
          );
          break;
        case 'TRU':
          header = isAvailableHeader ? (
            <HeaderContainerTRU
              handleLoginWithAuth0={this.handleLoginWithAuth0}
              handleLogoutWithAuth0={this.handleLogoutWithAuth0}
            />
          ) : (
            <HeaderTRU
              handleLoginWithAuth0={this.handleLoginWithAuth0}
              handleLogoutWithAuth0={this.handleLogoutWithAuth0}
            />
          );
          break;
        default:
          header = null;
          break;
      }
    }

    if (commonUtil.getChannel() === WAP && showHeader) {
      switch (brand) {
        case 'WS':
          header = isAvailableHeader ? (
            <Fragment>
              <HeaderContainerWS
                returnClickHandler={
                  hideWapHeaderForGiftList
                    ? this.giftListWapreturnClickHandler
                    : this.wapReturnClickHandler
                }
                handleLoginWithAuth0={this.handleLoginWithAuth0}
                handleLogoutWithAuth0={this.handleLogoutWithAuth0}
                routerPaths={Router}
                hideSearch={this.props.hideSearch}
              />
            </Fragment>
          ) : (
            <HeaderWSWap returnClickHandler={this.wapReturnClickHandler} />
          );
          break;
        case 'PB':
          header = isAvailableHeader ? (
            <Fragment>
              <HeaderContainerPB
                returnClickHandler={
                  hideWapHeaderForGiftList
                    ? this.giftListWapreturnClickHandler
                    : this.wapReturnClickHandler
                }
                handleLoginWithAuth0={this.handleLoginWithAuth0}
                handleLogoutWithAuth0={this.handleLogoutWithAuth0}
                routerPaths={Router}
                hideSearch={this.props.hideSearch}
              />
            </Fragment>
          ) : (
            <HeaderPBWap returnClickHandler={this.wapReturnClickHandler} />
          );
          break;
        case 'PBK':
          header = isAvailableHeader ? (
            <Fragment>
              <HeaderContainerPBK
                returnClickHandler={
                  hideWapHeaderForGiftList
                    ? this.giftListWapreturnClickHandler
                    : this.wapReturnClickHandler
                }
                handleLoginWithAuth0={this.handleLoginWithAuth0}
                handleLogoutWithAuth0={this.handleLogoutWithAuth0}
                routerPaths={Router}
                hideSearch={this.props.hideSearch}
              />
            </Fragment>
          ) : (
            <HeaderPBKWap returnClickHandler={this.wapReturnClickHandler} />
          );
          break;
        case 'GAP':
          header = isAvailableHeader ? (
            <Fragment>
              <HeaderContainerGAP
                returnClickHandler={
                  hideWapHeaderForGiftList
                    ? this.giftListWapreturnClickHandler
                    : this.wapReturnClickHandler
                }
                handleLoginWithAuth0={this.handleLoginWithAuth0}
                handleLogoutWithAuth0={this.handleLogoutWithAuth0}
                routerPaths={Router}
                hideSearch={this.props.hideSearch}
              />
            </Fragment>
          ) : (
            <HeaderGAPWap returnClickHandler={this.wapReturnClickHandler} />
          );
          break;
        case 'WLM':
          header = isAvailableHeader ? (
            <Fragment>
              <HeaderContainerWLM
                returnClickHandler={
                  hideWapHeaderForGiftList
                    ? this.giftListWapreturnClickHandler
                    : this.wapReturnClickHandler
                }
                handleLoginWithAuth0={this.handleLoginWithAuth0}
                handleLogoutWithAuth0={this.handleLogoutWithAuth0}
                routerPaths={Router}
                hideSearch={this.props.hideSearch}
              />
            </Fragment>
          ) : (
            <HeaderWESWap returnClickHandler={this.wapReturnClickHandler} />
          );
          break;
        case 'LP':
          header = isAvailableHeader ? (
            <Fragment>
              <HeaderContainer
                returnClickHandler={
                  hideWapHeaderForGiftList
                    ? this.giftListWapreturnClickHandler
                    : this.wapReturnClickHandler
                }
                handleLoginWithAuth0={this.handleLoginWithAuth0}
                handleLogoutWithAuth0={this.handleLogoutWithAuth0}
                routerPaths={Router}
                hideSearch={this.props.hideSearch}
              />
            </Fragment>
          ) : (
            <HeaderLPWAP returnClickHandler={this.wapReturnClickHandler} />
          );
          break;
        case 'TRU':
          header = isAvailableHeader ? (
            <Fragment>
              <HeaderContainerTRU
                returnClickHandler={
                  hideWapHeaderForGiftList
                    ? this.giftListWapreturnClickHandler
                    : this.wapReturnClickHandler
                }
                handleLoginWithAuth0={this.handleLoginWithAuth0}
                handleLogoutWithAuth0={this.handleLogoutWithAuth0}
                routerPaths={Router}
                hideSearch={this.props.hideSearch}
              />
            </Fragment>
          ) : (
            <HeaderTRUWap returnClickHandler={this.wapReturnClickHandler} />
          );
          break;
        default:
          header = null;
          break;
      }
    }

    return header;
  }
}
